import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import { Url } from '@wix/da-url';
import { useTranslation } from 'react-i18next';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import HiddenIcon from '@wix/da-ds/pkg/Icons/Hidden';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Button from '../../Button';
import Hidden from './Icons/Hidden';
import HiddenLayout from './HiddenLayout';
const MatureAnonymousBlockedOverlay = (props)=>{
    const { t  } = useTranslation();
    const sfwbrowse = useFlag('sfwbrowse');
    if (sfwbrowse) {
        return /*#__PURE__*/ React.createElement(HiddenLayout, _extends({
            icon: /*#__PURE__*/ React.createElement(HiddenIcon, {
                size: IconSize.HUGE
            }),
            text: t('deviationview.blocked.mature.text.sfwbrowse'),
            button: /*#__PURE__*/ React.createElement(GhostButton, {
                variant: "main",
                size: "medium",
                href: Url.joinLink('mature'),
                biData: {
                    evid: BiEventType.REDIRECT_TO_LOGIN,
                    referral_info: ReferralType.NSFG
                }
            }, t('deviationview.blocked.nsfg.anon.signIn'))
        }, props));
    }
    return /*#__PURE__*/ React.createElement(HiddenLayout, _extends({
        icon: /*#__PURE__*/ React.createElement(Hidden, null),
        title: t('deviationview.blocked.mature.anon'),
        text: props.compact ? null : t('deviationview.blocked.mature.anon.text'),
        button: /*#__PURE__*/ React.createElement(Button, {
            view: "b14",
            height: props.compact ? 'small' : 'medium',
            // Keeping joinpoint=mature since it was specifically requested in the ticket
            href: Url.joinLink('mature'),
            biData: {
                evid: BiEventType.REDIRECT_TO_LOGIN,
                referral_info: ReferralType.MATURE
            }
        }, t('deviationview.blocked.mature.anon.signIn'))
    }, props));
};
MatureAnonymousBlockedOverlay.displayName = 'MatureAnonymousBlockedOverlay';
export default MatureAnonymousBlockedOverlay;
